'use client';

import { createContext, useContext } from 'react';

import type { Dispatch, SetStateAction } from 'react';

const IsPlanSearchingContext = createContext<{
  isPlanSearching: boolean;
  setIsPlanSearching: Dispatch<SetStateAction<boolean>>;
} | null>(null);

export const useIsPlanSearching = () => {
  const isPlanSearching = useContext(IsPlanSearchingContext);

  if (isPlanSearching === null)
    throw new Error('component must be wrapped in IsPlanSearchingProvider');

  return isPlanSearching;
};

export const IsPlanSearchingProvider = IsPlanSearchingContext.Provider;
